/**
 * @author xyguo
 * @description 新开业培训要求记录管理
 * @Date 2021/3/16
 */
import React from 'react';
import {connect} from 'dva';
import {templateConfig, reduxTemplateCofig} from './config';
import {requirementBaseExcelColumns,requirementEXTExcelColumns} from "./excelColumns";

import {framework_tool, component_tool, utils_tool} from '@/tool'
import LookPositionAuthState from './lookPositionAuthState';

let {WizContainer, WizReduxTemplate} = framework_tool;
let {WizBrowserExport, WizCard, WizTabs, WizSpin, WizCol, WizRow,WizModal} = component_tool;
let {checkStrLength, Session} = utils_tool;
import moment from "moment";

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD') : '';
}
const formatterMinute = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}

const formatterType = (val) => {
  let newVal;
  switch (val) {
    case  1 :
      newVal = '经销商'
      break;
    case  2 :
      newVal = '服务商'
      break;
    case 99:
      newVal = '暂定'
      break;
    default :
      newVal = '无';
  }
  return newVal;
}

const formatterState = (val) => {
  if(val == null || val == undefined || val == -1){
    return "";
  }
  let newVal;
  switch (val) {
    case 0 :
      newVal = "● 合格"
      break;
    case 1 :
      newVal = "● 不合格"
      break;
    case 3 :
      newVal = "○"
      break;
    case 4 :
      newVal = ""
      break;
  }
  return newVal;
}


class RequirementPersonnelDetailList extends WizContainer {

  componentName = 'RequirementPersonnelDetailList';

  constructor(props) {
    super(props);
    let initialValue={}
    const {history} = props;
    if (history.location.record) {
      history.location.record.typeName = formatterType(history.location.record.type);
      Session.set('requirementPersonnelDetail', history.location.record);
      initialValue = history.location.record;
    } else if (Session.get('requirementPersonnelDetail')) {
      initialValue = Session.get('requirementPersonnelDetail') ? Session.get('requirementPersonnelDetail') : {};
    }
    this.state = {
      trainState: initialValue.state,
      scoreVisable: false,
      lookRecord:{},
      headList:[],
    }
    this.initialValue = initialValue;
  }

  _handleCMD = (nextProps, nextState, key) => {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      this.setState({
        trainState: 2
      })
      let record = Session.get('requirementPersonnelDetail') ? Session.get('requirementPersonnelDetail') : {};
      record.state = 2
      Session.set('requirementPersonnelDetail', record);
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }


  _handleFile=(nextProps, nextState, key)=> {
    let o = nextProps[key]
    let columnDefs =  [...requirementBaseExcelColumns];
    if(this.state.headList && this.state.headList.length){
      this.state.headList.forEach(element => {
        let requirementType = element.requirementType;
        requirementEXTExcelColumns.forEach(e=>{
          if(e.requirementType==requirementType){
            e.headerName = element.showTitle
            columnDefs.push(e);
          }
        })
      });
    }
    if (o['success']) {
      let data = o['data']
      data && data.forEach(e => {
        e.onlineState =  formatterState(e.onlineState);
        e.certState = formatterState(e.certState);
        e.offlineState = formatterState(e.offlineState);
        e.personnelState = formatterState(e.personnelState);
        e.resumeState = formatterState(e.resumeState);
        e.mbtiState = formatterState(e.mbtiState);
        e.interviewState = formatterState(e.interviewState);
        e.electricCertState = formatterState(e.electricCertState);
        e.positionAuthState = formatterState(e.positionAuthState);
        e.onlineExamState =  formatterState(e.onlineExamState);
        e.benchmarkState =  formatterState(e.benchmarkState);
      })

      let record = Session.get('requirementPersonnelDetail') ? Session.get('requirementPersonnelDetail') : {};
      let title = '经销商名称：' + record.dealerName + '\n'
        + '品牌：' + record.brandName + '\n'
        + '预估开业时间：' + formatterDate(record.openTime) + '\n'
        + '开店时间：' + formatterDate(record.dealerOpenTime) + '\n'
        + '销售代码：' + record.preSalesNumber + '\n'
        + '售后代码：' + record.afterSalesNumber + '\n'
        + '站点类型：' + record.typeName;

      WizBrowserExport({
        title: title,
        sheetName: '新开业人员培训详情',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '新开业人员培训详情.xlsx',
        titleParams: {
          alignment: {vertical: 'bottom', horizontal: 'left', wrapText: true},
          style: {
            alignment: {vertical: "bottom", horizontal: "left", wrapText: true},
          },
          font: {},
        },
        titleRow: {
          height: 105
        }
      })
      return true
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _showTitle(record) {
    let content = <WizCard title={'经销商信息'} bodyStyle={{paddingLeft: 20, paddingBottom: 25, paddingTop: 25}}>
      <WizRow>
        <WizCol span={8} offset={2}>
          经销商名称: {record.dealerName}
        </WizCol>
        <WizCol span={6}>
          品牌: {record.brandName}
        </WizCol>
        <WizCol span={8}>
          站点类型: {record.typeName}
        </WizCol>
      </WizRow>
      <WizRow style={{marginTop: 20}}>
        <WizCol span={8} offset={2}>
          销售代码: {record.preSalesNumber}
        </WizCol>
        <WizCol span={6}>
          售后代码: {record.afterSalesNumber}
        </WizCol>
        <WizCol span={8}>
          预估开业时间: {formatterDate(record.openTime)}
        </WizCol>
      </WizRow>
      <WizRow style={{marginTop: 20}}>
        <WizCol span={8} offset={2}>
          开店时间: {formatterDate(record.dealerOpenTime)}
        </WizCol>
        <WizCol>
        </WizCol>
      </WizRow>
    </WizCard>
    return content;
  }

  _handleHeadListData=(nextProps, nextState, key)=> {
    let o = nextProps[key]
    if (o['success']) {
      this.setState({
        headList: o.data
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let record = this.initialValue;
    const {type} = record;
    let _reduxTemplateCofig = reduxTemplateCofig({
      record,
      templateConfig: templateConfig(this.state.trainState, type,this,record,this.state.headList),
      apiDataFormat: {
        export: this._handleFile,
        dealerConfirm: this._handleCMD,
        headList: this._handleHeadListData,
      },
      keepInitApiParams: true,
    })
    //footer={null}
    return <>{this._showTitle(record)}
      <WizCard title={'新开业人员培训详情'}>
        <WizReduxTemplate {..._reduxTemplateCofig} style={{paddingTop: "100px"}}/>
        <WizModal visible={this.state.scoreVisable} footer={null}
           onOk={()=>this.setState({
            scoreVisable:false
           })}
           onCancel={()=>this.setState({
            scoreVisable:false
           })}
          >
          <LookPositionAuthState key ={new Date().getTime()}  record={this.state.lookRecord} />
        </WizModal>
      </WizCard>
    </>
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(RequirementPersonnelDetailList);
